import { render, staticRenderFns } from "./notification-template-table.vue?vue&type=template&id=b5b19570&scoped=true"
import script from "./notification-template-table.vue?vue&type=script&lang=js"
export * from "./notification-template-table.vue?vue&type=script&lang=js"
import style0 from "./notification-template-table.vue?vue&type=style&index=0&id=b5b19570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b19570",
  null
  
)

export default component.exports